import React from 'react';
import { useMetaPixel } from '../hooks/useMetaPixel';
import { CountdownBar } from './CountdownBar';
import { HeroSection } from './HeroSection';
import { PainPoints } from './PainPoints';
import { SolutionSection } from './SolutionSection';
import { BeforeAfter } from './BeforeAfter';
import { BonusSection } from './BonusSection';
import { PricingSection } from './PricingSection';
import { GuaranteeSection } from './GuaranteeSection';
import { TestimonialsSection } from './TestimonialsSection';
import { FAQSection } from './FAQSection';
import { FinalCTA } from './FinalCTA';
import { SocialProofPopup } from './SocialProofPopup';
export function SalesPage() {
  // Initialize Meta Pixel
  useMetaPixel();
  return <div className="min-h-screen bg-white font-sans selection:bg-yellow-300 selection:text-black pt-8 sm:pt-9" data-id="element-200">
      <CountdownBar data-id="element-201" />

      <main data-id="element-202">
        <HeroSection data-id="element-203" />
        <PainPoints data-id="element-204" />
        <SolutionSection data-id="element-205" />
        <BeforeAfter data-id="element-206" />
        <BonusSection data-id="element-207" />
        <PricingSection data-id="element-208" />
        <GuaranteeSection data-id="element-209" />
        <TestimonialsSection data-id="element-210" />
        <FAQSection data-id="element-211" />
        <FinalCTA data-id="element-212" />
      </main>

      <SocialProofPopup data-id="element-213" />
    </div>;
}